import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/client.js';
import { Loader, Alert, formatDate } from '../../components/ui.jsx';
import CubMascot from '../../components/CubMascot.jsx';

export default function Badges() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.studentDashboard().then(setData).catch((err) => setError(err.message));
  }, []);

  if (error) return <Alert kind="bad">{error}</Alert>;
  if (!data) return <Loader label="Polishing your trophies…" />;

  const earned = data.badges.filter((b) => b.awarded_at);

  return (
    <>
      <div className="page-head">
        <div>
          <h1>🏅 My badge shelf</h1>
          <p>
            You have collected <strong>{earned.length}</strong> of {data.badges.length} badges.
            {earned.length < data.badges.length && ' Finish more lessons to unlock the rest!'}
          </p>
        </div>
        <Link to="/learn" className="btn btn-ghost">← Back to my courses</Link>
      </div>

      {earned.length === 0 && (
        <div className="badge-empty">
          <CubMascot avatar="cub-sky" mood="think" size={120} />
          <div>
            <h3>No badges yet — but not for long!</h3>
            <p className="muted">
              Finish your first lesson quiz and your first badge lands right here.
            </p>
            <Link to="/learn" className="btn mt-md">Start learning →</Link>
          </div>
        </div>
      )}

      <div className="badge-grid">
        {data.badges.map((b) => (
          <div key={b.slug} className={`badge-tile ${b.awarded_at ? 'is-earned' : 'is-locked'}`}>
            <span className="badge-tile-icon" aria-hidden="true">
              {b.awarded_at ? b.icon : '🔒'}
            </span>
            <h3>{b.title}</h3>
            <p className="small muted">{b.description}</p>
            {b.awarded_at ? (
              <span className="pill pill-good">Earned {formatDate(b.awarded_at)}</span>
            ) : (
              <span className="pill">Not yet earned</span>
            )}
          </div>
        ))}
      </div>

      {data.recent?.length > 0 && (
        <section className="mt-lg">
          <h2>📋 Recent quiz attempts</h2>
          <div className="card-flat">
            <ul className="login-history">
              {data.recent.map((r, i) => (
                <li key={i}>
                  <span>
                    <span aria-hidden="true">{r.icon}</span> {r.title}
                  </span>
                  <span className="muted">
                    {r.score}/{r.total} · {formatDate(r.created_at, true)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </section>
      )}
    </>
  );
}
